import { createContext } from 'react'
import type { LanguageCode } from './languages'
import type { MessageKey } from './messages'

/** Values interpolated into a message via `{name}` placeholders. */
export type TranslateVars = Record<string, string | number>

/** Look up a message by key, optionally filling `{placeholders}`. */
export type Translate = (key: MessageKey, vars?: TranslateVars) => string

export interface I18nContextValue {
  /** Active locale. */
  locale: LanguageCode
  /** Switch locale (persists + updates `<html lang>`). */
  setLocale: (code: LanguageCode) => void
  /** Translate function bound to the active locale. */
  t: Translate
}

export const I18nContext = createContext<I18nContextValue | null>(null)
